export default __webpack_public_path__ + "static/media/misc-books4-1920w.b6cb8a0d.png";